import "./window.Extensions";
import Map from 'ol/Map';
import View from 'ol/View';
import GeoJSON from "ol/format/GeoJSON"
import { Tile as TileLayer, Vector as VectorLayer, Group as LayerGroup } from 'ol/layer';
import { OSM, BingMaps, Vector as VectorSource } from 'ol/source';
import { LayerManager } from "./LayerManager";
import defaultStyleFunc from "./DefaultStyle";
import * as baseMaps from "./baseMap";

class MapInterop {
    constructor() {
        this.analysisModules = {};
        //this.interop = {};
        this._layerManager = new LayerManager();
    }
    map: Map = null;
    baseMap: TileLayer| LayerGroup;
    _layerManager: LayerManager;

    public get Map() {
        return this.map;
    }

    //private interop: {
    //    [key: string]: any;
    //}

    //public registerInterop(key: string, module: any) {
    //    this.interop[key] = module;
    //}

    private analysisModules: {
        [ket:string]:any;
    };

    public get analysis() {
        return this.analysisModules;
    }

    public registerAnalysis(analysisName: string, analysisModule: any) {
        this.analysisModules[analysisName] = analysisModule;
    }

    public get layerManager() {
        return this._layerManager;
    }

    public set layerManager(value: LayerManager) {
        this._layerManager = value;
    }

    init(dom: any) {
        this.baseMap = new TileLayer({
            source: new OSM()
        });
        this.map = new Map({
            layers: [this.baseMap],
            target: dom,
            view: new View({
                projection: 'EPSG:4326',
                center: [129, 31],
                zoom: 4
            })
        });
    }

    addGeoJson(geoJsonObj: string, layerName: string = null) {
        var vectorSource = new VectorSource({
            features: (new GeoJSON()).readFeatures(geoJsonObj)
        });
        var vectorLayer = new VectorLayer({
            source: vectorSource,
            style: defaultStyleFunc
        });
        this.addLayer(vectorLayer, layerName);
    }
    layerCount:number = 0;
    addLayer(vectorLayer: VectorLayer, layerName: string = null) {
        if (!layerName) {
            layerName = "Layer" + this.layerManager.count;
        }
        vectorLayer.set("vLayerName", layerName);
        //window.vMap.Map.addLayer(vectorLayer);
        this.layerManager.add(layerName, vectorLayer);
    }

    removeLayer(layerName: string) {
        var layer = this.layerManager.get(layerName);
        if (layer) {
            this.layerManager.remove(layerName);
        }
    }
    
    changeBaseMap(mapId: baseMaps.MapIdType, apiKey: string) {

        let baseMap: TileLayer | LayerGroup;
        let mapIdType = baseMaps.MapIdType;
        switch (mapId) {
            case mapIdType.TianDiTu:
            {
                baseMap = baseMaps.tdt(apiKey);
                break;
            }
            case mapIdType.Bing:
            {
                let bingMapStyles = [
                    'Road',
                    'Aerial',
                    'AerialWithLabels',
                    'collinsBart',
                    'ordnanceSurvey'
                ];
                baseMap = new TileLayer({
                    source: new BingMaps({
                        key: apiKey,
                        imagerySet: bingMapStyles[0],
                        hidpi:true,
                    })
                });
                break;
            }
            default:
                baseMap = new TileLayer({
                    source: new OSM()
                });
                break;
        }
        this.map.removeLayer(this.baseMap);
        this.baseMap = baseMap;
        this.baseMap.setZIndex(-100);
        this.map.addLayer(this.baseMap);
    }

    getLayerNames() {
        let allNames = [];
        for (var key in this.layerManager.getAll()) {
            allNames.push(key);
        }
        console.log("allNames", allNames);
        return allNames;
    }

}

//const mapInterop = new MapInterop();


//window.vMap = mapInterop;

export { MapInterop}
